import { get } from "../libs/https";

const whitelist = ["register", "invite"];
const publicPath = process.env.BASE_URL;

export const AuthGuard = async (to, from, next) => {
  let token = window.sessionStorage.getItem("access_token");
  let puid = window.sessionStorage.getItem("puid");

  if (whitelist.includes(to.name)) {
    next();
    return
  }

  if (to.path === "/logout" ) {
    if (window.sessionStorage.getItem('puid') && window.sessionStorage.getItem('access_token')) {
      await get(`${publicPath}api/auth/logout`);
      window.sessionStorage.clear();
      next({ path: `/login` });
    } else {
      next({ path: `/login` });
    }
    return;
  }

  if (to.path !== "/login") {
    if (!token || !puid) {
      next({ path:`/login` });
      return;
    }
  }

  let valid = false

  if (token && puid) {
    valid = await TokenCheck();
  }

  if (to.path === "/login" && valid && puid) {
    next({ path: `/` });
    return;
  } else {
    next();
  }

  if (valid && token && puid) {
    next();
  } else {
    next({ path: `/login` });
    window.sessionStorage.clear();
  }

};

export const TokenCheck = async () => {
  CheckInterval()
  let res = await get(`${publicPath}api/auth`);
  return res.authentication;
};
let set = false

const CheckInterval = async () => {
  if (!set) {
    set = true
    setInterval(async () => {
      let valid = await TokenCheck();
      
      if (!valid) {
        window.location.href = `${publicPath}logout`
      }
    }, 300000)
  }
  return
}
